import { wrap as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const {
    theme: { nestedDropdownSpan },
  } = props

  return `
      .nestedDropdownSpan {
        margin Left: 6px;
        color: ${nestedDropdownSpan};
      }
      .nestedAntDropdownLink {
        margin-right: 6px;
      }
}
  `
})
